export default __webpack_public_path__ + "static/media/home.689f695f.svg";